'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _deepClone = require('../../utils/deep-clone');

var _deepClone2 = _interopRequireDefault(_deepClone);

var _getDeviceUtil = require('../../utils/get-device-util');

var _getDeviceUtil2 = _interopRequireDefault(_getDeviceUtil);

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _button = require('../button/button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _title = require('../title');

var _title2 = _interopRequireDefault(_title);

var _tableBody = require('./table-body/table-body');

var _tableBody2 = _interopRequireDefault(_tableBody);

require('./table.scss');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logger = new _logger2.default();

var RENDER_NO_DATA_PARAMS = { classes: { presentationalIcon: 'table__no-data-icon-wrapper' } };

var Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {
      selectedRows: []
    };

    _this.tableRef = null;

    _this.onTableClick = _this.onTableClick.bind(_this);
    return _this;
  }

  _createClass(Table, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var selectedRows = this.props.selectedRows;


      if (selectedRows) {
        this.setState({
          selectedRows: [].concat(_toConsumableArray(new Set(selectedRows)))
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onCellSelection) {
        this.tableRef.addEventListener('click', this.onTableClick, false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedRows) {
        this.setState({
          selectedRows: [].concat(_toConsumableArray(new Set(nextProps.selectedRows)))
        });
      }

      if (!nextProps.onCellSelection && this.props.onCellSelection) {
        this.tableRef.removeEventListener('click', this.onTableClick, false);
      }

      if (nextProps.onCellSelection && !this.props.onCellSelection) {
        this.tableRef.addEventListener('click', this.onTableClick, false);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.data.length !== this.props.data.length) {
        this.setState({ selectedRows: [] });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.tableRef.removeEventListener('click', this.onTableClick, false);
    }
  }, {
    key: 'onRowSelection',
    value: function onRowSelection(selectedRows) {
      this.props.onRowSelection(selectedRows);
    }
  }, {
    key: 'onContextMenuHandler',
    value: function onContextMenuHandler(selectedRow) {
      // TODO remove getDeviceInformation, refactor FM to select row onRowContext and remove this method
      if (!this.props.selectable || !(0, _getDeviceUtil2.default)().isDesktop) {
        return;
      }

      if (this.state.selectedRows.length <= 1) {
        this.setState({ selectedRows: [selectedRow] }, this.onRowSelection([selectedRow]));
        return;
      }

      this.onRowSelection(this.state.selectedRows);
    }
  }, {
    key: 'onTableClick',
    value: function onTableClick(e) {
      var el = e.target;
      var tagName = el.tagName;

      if (tagName !== 'td') {
        el = el.closest('td');
      }

      if (el === null) {
        return;
      }

      var rowIndex = Number(el.getAttribute('data-row-index'));
      var colIndex = Number(el.getAttribute('data-cell-index'));

      this.props.onCellSelection({ rowIndex: rowIndex, colIndex: colIndex });
    }
  }, {
    key: 'getColumnsToRender',
    value: function getColumnsToRender() {
      var _this2 = this;

      var _props = this.props,
          reordable = _props.reordable,
          columns = _props.columns,
          expandableTemplate = _props.expandableTemplate,
          onExpandToggle = _props.onExpandToggle;

      var expandable = Boolean(expandableTemplate);

      if (reordable || expandable) {
        var modifiedColumns = (0, _deepClone2.default)(columns);
        var config = {
          wrapperClass: reordable ? 'table__cell-dnd-wrapper' : 'table__cell-expandable-wrapper',
          inactiveIcon: {
            inactiveClass: reordable ? 'icon-gripper icon-dnd' : 'icon-expandable',
            icon: reordable ? 'gripper' : 'circle-plus',
            iconColor: reordable ? null : 'secondary',
            onClick: reordable ? null : function (row) {
              return onExpandToggle(row);
            }
          },
          activeIcon: {
            inactiveClass: reordable ? 'icon-move icon-dnd' : 'icon-expandable',
            icon: reordable ? 'move' : 'circle-minus',
            iconColor: reordable ? null : 'secondary',
            onClick: reordable ? null : function (row) {
              return onExpandToggle(row);
            }
          }
        };

        modifiedColumns[0].render = function (cell, row) {
          var isRowExpanded = _this2.isExpandedRowInComponentProps(row);

          return _react2.default.createElement(
            'div',
            { className: config.wrapperClass },
            isRowExpanded || _react2.default.createElement(_icon2.default, {
              color: config.inactiveIcon.iconColor,
              className: config.inactiveIcon.inactiveClass,
              name: config.inactiveIcon.icon,
              size: '18',
              onClick: function onClick() {
                return config.inactiveIcon.onClick(row);
              }
            }),
            isRowExpanded && _react2.default.createElement(_icon2.default, {
              color: config.inactiveIcon.iconColor,
              className: config.activeIcon.inactiveClass,
              name: config.activeIcon.icon,
              size: '18',
              onClick: function onClick() {
                return config.activeIcon.onClick(row);
              }
            }),
            columns[0].render ? columns[0].render(cell, row) : cell
          );
        };

        return modifiedColumns;
      }

      return columns;
    }
  }, {
    key: 'getEventKeys',
    value: function getEventKeys(event) {
      if (event.srcEvent) {
        return {
          ctrlKey: event.srcEvent.ctrlKey,
          metaKey: event.srcEvent.metaKey,
          shiftKey: event.srcEvent.shiftKey
        };
      }

      return {
        ctrlKey: event.srcEvent.ctrlKey,
        metaKey: event.srcEvent.metaKey,
        shiftKey: event.srcEvent.shiftKey
      };
    }
  }, {
    key: 'isSelectedRowInComponentState',
    value: function isSelectedRowInComponentState(row) {
      var _this3 = this;

      return Boolean(this.state.selectedRows.find(function (entity) {
        return _this3.areObjectsEqual(entity, row);
      }));
    }
  }, {
    key: 'isExpandedRowInComponentProps',
    value: function isExpandedRowInComponentProps(row) {
      var _this4 = this;

      var expandedRows = this.props.expandedRows;

      return Boolean(expandedRows) && Boolean(expandedRows.find(function (entity) {
        return _this4.areObjectsEqual(entity, row);
      }));
    }
  }, {
    key: 'areObjectsEqual',
    value: function areObjectsEqual(firstObject, secondObject) {
      return JSON.stringify(firstObject) === JSON.stringify(secondObject);
    }
  }, {
    key: 'toggleRowSelection',
    value: function toggleRowSelection(row) {
      var newSelectedRows = this.isSelectedRowInComponentState(row) ? [] : [row];

      this.setState({ selectedRows: newSelectedRows }, this.onRowSelection(newSelectedRows));
    }
  }, {
    key: 'toggleRowsSelection',
    value: function toggleRowsSelection(row, event) {
      var _this5 = this;

      var data = this.props.data;

      var _getEventKeys = this.getEventKeys(event),
          ctrlKey = _getEventKeys.ctrlKey,
          metaKey = _getEventKeys.metaKey,
          shiftKey = _getEventKeys.shiftKey;

      var rowIndex = data.findIndex(function (entity) {
        return _this5.areObjectsEqual(entity, row);
      });
      var newSelectedRows = [];

      if (shiftKey) {
        var firstRowIndexThatIsSelected = data.findIndex(function (entity) {
          return _this5.areObjectsEqual(entity, _this5.state.selectedRows[0]);
        });
        var previousRowIndex = this.state.selectedRows.length > 0 ? firstRowIndexThatIsSelected : rowIndex;
        var startIndex = Math.min(rowIndex, previousRowIndex);
        var endIndex = Math.max(rowIndex, previousRowIndex);

        for (var i = startIndex; i <= endIndex; i++) {
          newSelectedRows.push(data[i]);
        }
      }

      if (ctrlKey || metaKey) {
        newSelectedRows = newSelectedRows.concat(this.state.selectedRows);

        if (this.isSelectedRowInComponentState(row)) {
          newSelectedRows = this.state.selectedRows.filter(function (entity) {
            return _this5.areObjectsEqual(entity, row);
          });
        } else {
          newSelectedRows.push(data[rowIndex]);
        }
      }

      this.setState({ selectedRows: newSelectedRows }, this.onRowSelection(newSelectedRows));
    }
  }, {
    key: 'rowSelectionHandler',
    value: function rowSelectionHandler(row, event) {
      var _getEventKeys2 = this.getEventKeys(event),
          ctrlKey = _getEventKeys2.ctrlKey,
          metaKey = _getEventKeys2.metaKey,
          shiftKey = _getEventKeys2.shiftKey;

      if (this.props.selectable === false) {
        return;
      }

      if (shiftKey || ctrlKey || metaKey) {
        this.toggleRowsSelection(row, event);
        return;
      }

      this.toggleRowSelection(row, event);
    }
  }, {
    key: 'isColumnSelected',
    value: function isColumnSelected(colIndex) {
      return this.props.selectedColumns.includes(colIndex);
    }
  }, {
    key: 'renderHead',
    value: function renderHead() {
      var _this6 = this;

      var headerBackground = this.props.headerBackground;

      var classes = (0, _classnames2.default)('table__head', 'table__head--background-' + headerBackground);

      var columns = this.getColumnsToRender();
      if (columns.length === 0) {
        return null;
      }

      if (!columns.find(function (colomn) {
        return colomn.header;
      })) {
        return null;
      }

      return _react2.default.createElement(
        'thead',
        { className: classes },
        _react2.default.createElement(
          'tr',
          null,
          columns.map(function (cell, i) {
            // For Deprecated
            var cellRender = cell.renderHead ? cell.renderHead : cell.header;
            // eslint-disable-next-line
            var columnName = cell.header !== undefined ? cell.header : cell.accessor;
            logger.log('"column.renderHead" will be deprecated in favor of "column.render" ');
            logger.log('Using "cell.accessor" as default column header will be deprecated.');
            // End For Deprecated

            var isColumnSelected = _this6.isColumnSelected(i);
            var classesTh = (0, _classnames2.default)('table__cell', isColumnSelected && 'table__cell--is-selected');
            return _react2.default.createElement(
              'th',
              {
                className: classesTh,
                key: i,
                style: _extends({}, cell.style),
                'data-cell-index': i
              },
              typeof cellRender === 'function' ? cellRender(columnName) : columnName
            );
          })
        )
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _this7 = this;

      var _props2 = this.props,
          footerBackground = _props2.footerBackground,
          columns = _props2.columns;


      var classes = (0, _classnames2.default)('table__footer', 'table__footer--background-' + footerBackground);

      if (!(0, _utils.hasFooter)(columns)) {
        return null;
      }

      return _react2.default.createElement(
        'tfoot',
        { className: classes },
        _react2.default.createElement(
          'tr',
          null,
          columns.map(function (cell, i) {
            var isColumnSelected = _this7.isColumnSelected(i);
            var classesTd = (0, _classnames2.default)('table__cell', isColumnSelected && 'table__cell--is-selected');

            logger.log('Using "cell.renderFooterCell" as function will be deprecated.');
            return _react2.default.createElement(
              'td',
              {
                className: classesTd,
                key: 'table-footer-' + i,
                style: _extends({}, cell.style),
                'data-cell-index': i
              },
              cell.footer ? _this7.renderFooterCell(cell) : ''
            );
          })
        )
      );
    }
  }, {
    key: 'renderFooterCell',
    value: function renderFooterCell(cell) {
      // For Deprecated
      return typeof cell.footer === 'function' ? cell.footer() : cell.footer;
      // return cell.footer
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this8 = this;

      var _props3 = this.props,
          data = _props3.data,
          onReorder = _props3.onReorder,
          onRowPress = _props3.onRowPress,
          onRowTap = _props3.onRowTap,
          reordable = _props3.reordable,
          rowKey = _props3.rowKey,
          selectedColumns = _props3.selectedColumns,
          shouldRowLoading = _props3.shouldRowLoading,
          expandableTemplate = _props3.expandableTemplate;


      return _react2.default.createElement(_tableBody2.default, {
        columns: this.getColumnsToRender(),
        data: data,
        expandableTemplate: expandableTemplate,
        isSelectedRowInComponentState: function isSelectedRowInComponentState(row) {
          return _this8.isSelectedRowInComponentState(row);
        },
        isExpandedRowInComponentProps: function isExpandedRowInComponentProps(row) {
          return _this8.isExpandedRowInComponentProps(row);
        },
        onContextMenuHandler: function onContextMenuHandler(row) {
          return _this8.onContextMenuHandler(row);
        },
        onReorder: onReorder,
        onRowPress: onRowPress,
        onRowTap: onRowTap,
        reordable: reordable,
        rowKey: rowKey,
        rowSelectionHandler: function rowSelectionHandler(row, event) {
          return _this8.rowSelectionHandler(row, event);
        },
        shouldRowLoading: shouldRowLoading,
        selectedColumns: selectedColumns,
        tableRef: this.tableRef
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var _props4 = this.props,
          className = _props4.className,
          columns = _props4.columns,
          data = _props4.data,
          density = _props4.density,
          disableTableHead = _props4.disableTableHead,
          enableMobile = _props4.enableMobile,
          expandableTemplate = _props4.expandableTemplate,
          onLoadMore = _props4.onLoadMore,
          reordable = _props4.reordable,
          shadow = _props4.shadow,
          showLoadMore = _props4.showLoadMore,
          translation = _props4.translation,
          props = _objectWithoutProperties(_props4, ['className', 'columns', 'data', 'density', 'disableTableHead', 'enableMobile', 'expandableTemplate', 'onLoadMore', 'reordable', 'shadow', 'showLoadMore', 'translation']);

      var expandedRows = props.expandedRows,
          selectable = props.selectable,
          selectedRows = props.selectedRows,
          rowKey = props.rowKey,
          onExpandToggle = props.onExpandToggle,
          onRowSelection = props.onRowSelection,
          onCellSelection = props.onCellSelection,
          selectedColumns = props.selectedColumns,
          onReorder = props.onReorder,
          renderNoData = props.renderNoData,
          renderBeforeTableContent = props.renderBeforeTableContent,
          headerBackground = props.headerBackground,
          footerBackground = props.footerBackground,
          onRowTap = props.onRowTap,
          onRowPress = props.onRowPress,
          shouldRowLoading = props.shouldRowLoading,
          propsToPropagate = _objectWithoutProperties(props, ['expandedRows', 'selectable', 'selectedRows', 'rowKey', 'onExpandToggle', 'onRowSelection', 'onCellSelection', 'selectedColumns', 'onReorder', 'renderNoData', 'renderBeforeTableContent', 'headerBackground', 'footerBackground', 'onRowTap', 'onRowPress', 'shouldRowLoading']);

      var expandable = Boolean(expandableTemplate);

      var classesWrapper = (0, _classnames2.default)('table-wrapper', shadow && 'table-wrapper--box-shadow', density && 'table-wrapper--density-' + density, enableMobile && 'table-wrapper--mobile', expandable && 'table-wrapper--expandable', className);
      var classesTable = (0, _classnames2.default)('table', !(0, _utils.hasFooter)(columns) && 'table--no-footer');

      return _react2.default.createElement(
        'div',
        { className: classesWrapper },
        renderBeforeTableContent(),
        _react2.default.createElement(
          'table',
          _extends({
            className: classesTable,
            ref: function ref(_ref) {
              _this9.tableRef = _ref;
            }
          }, propsToPropagate),
          !disableTableHead && this.renderHead(),
          data.length > 0 && this.renderBody(),
          this.renderFooter()
        ),
        data.length === 0 && _react2.default.createElement(
          'div',
          { className: 'table__no-data' },
          renderNoData(RENDER_NO_DATA_PARAMS)
        ),
        showLoadMore && _react2.default.createElement(
          'div',
          { className: 'table-load-more' },
          _react2.default.createElement(
            _button2.default,
            { type: 'link', onClick: onLoadMore },
            translation.loadMoreText
          )
        )
      );
    }
  }]);

  return Table;
}(_react2.default.Component);

Table.propTypes = {
  columns: _propTypes2.default.array,
  className: _propTypes2.default.string,
  data: _propTypes2.default.array,
  density: _propTypes2.default.oneOf(['none', 'medium', 'large']),
  disableTableHead: _propTypes2.default.bool,
  enableMobile: _propTypes2.default.bool,
  expandedRows: _propTypes2.default.array,
  expandableTemplate: _propTypes2.default.func,
  headerBackground: _propTypes2.default.oneOf(['default', 'white']),
  footerBackground: _propTypes2.default.oneOf(['default', 'white']),
  shadow: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  selectedRows: _propTypes2.default.array,
  selectedColumns: _propTypes2.default.array,
  reordable: _propTypes2.default.bool,
  rowKey: _propTypes2.default.string,
  showLoadMore: _propTypes2.default.bool,
  onExpandToggle: _propTypes2.default.func,
  onLoadMore: _propTypes2.default.func,
  onRowSelection: _propTypes2.default.func,
  onRowTap: _propTypes2.default.func,
  onRowPress: _propTypes2.default.func,
  onCellSelection: _propTypes2.default.func,
  onReorder: _propTypes2.default.func,
  shouldRowLoading: _propTypes2.default.func, // TODO change this name when there is an agreement about what will do
  renderNoData: _propTypes2.default.func,
  renderBeforeTableContent: _propTypes2.default.func,
  translation: _propTypes2.default.object
};

Table.defaultProps = {
  columns: [],
  data: [],
  density: 'medium',
  disableTableHead: false,
  enableMobile: true,
  selectable: false,
  headerBackground: 'default',
  footerBackground: 'default',
  selectedColumns: [],
  onExpandToggle: function onExpandToggle() {},
  onRowSelection: function onRowSelection() {},
  onRowTap: function onRowTap() {},
  onRowPress: function onRowPress() {},
  renderNoData: function renderNoData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RENDER_NO_DATA_PARAMS;
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        'div',
        { className: params.classes.presentationalIcon },
        _react2.default.createElement(_icon2.default, { name: 'product-island', size: '64' })
      ),
      _react2.default.createElement(
        _title2.default,
        { level: '4', color: 'light', density: 'none' },
        'Nothing here yet.'
      )
    );
  },
  renderBeforeTableContent: function renderBeforeTableContent() {
    return null;
  },
  shouldRowLoading: function shouldRowLoading() {
    return false;
  },
  reordable: false,
  shadow: false,
  translation: {
    loadMoreText: 'Load More'
  }
};

exports.default = Table;